import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  enlaceClase79: Yup.string().required(),
  enlaceClase80: Yup.string().required(),
  enlaceClase89: Yup.string().required()
})
